import { AppTitle } from 'uno-material-ui';

export const Title = AppTitle('passcorepro - ', '');
